/* eslint-disable max-len */
import auth0 from '@/utils/auth0';
import DDLogs from '@/DDLogs';
import OpenBankingLandingPage from '@/pages/responsive-pages/non-authenticated/open-banking/OpenBankingLandingPage.vue';
import store from '@/store';
import OtsInsightsResults from '@/pages/responsive-pages/authenticated/ots/OtsInsightsResults.vue';
import OtsMortgageRefinance from '@/pages/responsive-pages/authenticated/ots/OtsMortgageRefinance.vue';
import AgamResults from '@/pages/responsive-pages/authenticated/ots/AgamResults.vue';
import MortgageResultsPage from '@/pages/responsive-pages/authenticated/navigation-pages/mortgage-results/MortgageResultsPage.vue';
import NoMortgageDataUploadPage from '@/pages/responsive-pages/authenticated/navigation-pages/mortgages/NoMortgageDataUploadPage.vue';
import NoMortgagePage from '@/pages/responsive-pages/authenticated/navigation-pages/mortgages/NoMortgagePage.vue';
import NoMortgageDataAlternativesPage from '@/pages/responsive-pages/authenticated/navigation-pages/mortgages/NoMortgageDataAlternativesPage.vue';

const OtsResults = () => import(/* webpackChunkName: "authenticated-base" */ '@/pages/responsive-pages/authenticated/ots/OtsResults.vue');
const AgamFlow = () => import(/* webpackChunkName: "authenticated-base" */ '@/pages/responsive-pages/authenticated/ots/AgamFlow');
const OnboardFlowOts = () => import(/* webpackChunkName: "authenticated-base" */ '../pages/responsive-pages/authenticated/onboard2/OnboardFlowOts');
const OtsConnectFlow = () => import(/* webpackChunkName: "authenticated-base" */ '../pages/responsive-pages/authenticated/onboard2/OtsConnectFlow');

// eslint-disable-next-line import/prefer-default-export
export const otsAuthenticatedRoutes = [
  {
    path: 'agam',
    name: 'AgamFlow',
    component: AgamFlow,
  },
  {
    path: 'agam-results',
    name: 'AgamResults',
    component: AgamResults,
  },
  {
    path: 'results',
    name: 'OtsResults',
    component: OtsResults,
  },
  {
    path: 'mortgage-results',
    name: 'MortgageResults',
    component: MortgageResultsPage,
    meta: {
      routerBack: true,
    },
  },
  {
    path: 'mortgage',
    name: 'Mortgages',
    component: OtsMortgageRefinance,
    meta: {
      routerBack: true,
    },
  },
  {
    path: 'new-mortgage',
    name: 'NoMortgagePage',
    component: NoMortgagePage,
    meta: {
      routerBack: true,
    },
  },
  {
    path: 'recycle-mortgage',
    name: 'NoMortgageDataAlternativesPage',
    component: NoMortgageDataAlternativesPage,
    meta: {
      routerBack: true,
    },
  },
  {
    path: 'upload-mortgage-report',
    name: 'UploadMortgageReportPage',
    component: NoMortgageDataUploadPage,
    meta: {
      routerBack: true,
    },
  },
  {
    path: ':source/welcome-back',
    name: 'OpenBankingLandingPage',
    component: OpenBankingLandingPage,
    meta: {
      preventRouterBack: true,
    },
  },
  {
    path: 'ots-insights-results',
    name: 'OtsInsigthsResults',
    component: OtsInsightsResults,
  },
  {
    path: 'decode-and-redirect/:encodedUrl',
    name: 'OtsDecodeAndRedirect',
    async beforeEnter(to, from, next) {
      const { path, params } = auth0.decodeUrl(to.params.encodedUrl);
      DDLogs.log('Redirecting path', { redirectedFrom: to.path });
      next({ path: `/${path}`, query: params });
    },
  },
  {
    path: 'ots-ob',
    name: 'OtsOnboard',
    component: OnboardFlowOts,
    async beforeEnter(to, from, next) {
      await store.dispatch('credentials/fetchObkSourceConfigurations');
      next();
    },
  },
  {
    path: 'connect',
    name: 'OtsConnect',
    component: OtsConnectFlow,
    async beforeEnter(to, from, next) {
      await store.dispatch('credentials/fetchObkSourceConfigurations');
      next();
    },
  },
  {
    path: '*',
    redirect: { name: 'OtsAuthenticateToken' },
  },
];
